import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/error/NotFound.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/lib/i18n/provider.tsx");
